// Nidalee — Javelin Toss / Pounce: hurls a spear at the front enemy, then transforms
// into cougar form and leaps onto them for a follow-up bite.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const nidaleeJavelin: Ability = {
  id: "nidaleeJavelin",
  displayName: "Javelin Toss / Pounce",
  description: "Hurls a javelin at the nearest enemy, then transforms into cougar form and pounces on them for a bonus bite.",
  iconId: "NidaleeQ",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return front ? [front.pos] : [caster.pos];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    if (!target) return [];
    const stats = effectiveStats(caster);
    return [
      { target, amount: physicalDamage(stats.ad * 1.4 + 60), type: "physical", suppressPopup: true, nidaleeSpear: true },
      { target, amount: physicalDamage(stats.ad * 1.1 + 40), type: "physical", suppressPopup: true, nidaleeBite: true },
    ];
  },
};
